import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outerStack: {
            gap: {base: remCalc(24), lg: remCalc(40)},
        },
        title: {
            textStyle: 'head-xlarge',
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            fontWeight: 'medium',
            py: remCalc(24),
        },
        errorBox: {
            mb: 4,
        },
        errorText: {
            fontWeight: 'bold',
            color: 'red.500',
        },
        noOrdersTitle: {
            color: 'text.default',
            fontWeight: 'medium',
            textStyle: 'head-medium',
        },
    },
    parts: ['title'],
}
